"use strict";
/**
 * 合并对象（深拷贝）
 *
 * ### Example
 * ```
 * deepAssign({}, { a: 1, b: 1 }, { b: 2, c: 3 }); // { a: 1, b: 2, c: 3 }
 * ```
 */
Object.defineProperty(exports, "__esModule", { value: true });
var hasOwnProperty = Object.prototype.hasOwnProperty;
function isObj(x) {
    var type = typeof x;
    return x !== null && (type === 'object' || type === 'function');
}
function assignKey(to, from, key) {
    var val = from[key];
    if ((val === undefined || val === null) ||
        (hasOwnProperty.call(to, key) && (to[key] === undefined || to[key] === null))) {
        return;
    }
    if (!hasOwnProperty.call(to, key) || !isObj(val)) {
        to[key] = val;
    }
    else {
        to[key] = assign(Object(to[key]), from[key]);
    }
}
function assign(to, from) {
    if (to !== from) {
        from = Object(from);
        for (var key in from) {
            if (hasOwnProperty.call(from, key)) {
                assignKey(to, from, key);
            }
        }
    }
    return to;
}
function deepAssign(target) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    args.forEach(function (from) {
        assign(target, from);
    });
    return target;
}
exports.deepAssign = deepAssign;
;
